import React, { createContext, useContext, useReducer } from 'react';

const FORM_UPDATE = 'FORM_UPDATE';
const FIELD_INVALID = 'FIELD_INVALID';
const FIELD_VALID = 'FIELD_VALID';

const FormReducer = (state, action) => {
	switch (action.type) {
		case FORM_UPDATE:
			return {
				...state,
				values: action.values,
			};
		case FIELD_INVALID:
			const validationMessageHasNotChanged =
				state.validationMessages.hasOwnProperty(action.field.id) &&
				state.validationMessages[action.field.id].message &&
				state.validationMessages[action.field.id].message ===
					action.field.message;

			if (
				state.invalidFields.includes(action.field.id) &&
				validationMessageHasNotChanged
			) {
				return state;
			}

			const currentInvalidFields = state.invalidFields.slice(0).filter(item => {
				return item !== action.field.id;
			});

			return {
				...state,
				invalidFields: [...currentInvalidFields, action.field.id],
				validationMessages: {
					...state.validationMessages,
					[action.field.id]: action.field,
				},
			};
		case FIELD_VALID:
			const updatedFields = state.invalidFields.slice(0).filter(item => {
				return item !== action.field.id;
			});

			let updatedMessages = { ...state.validationMesssages };

			if (Object.keys(updatedMessages).length > 0) {
				updatedMessages = Object.keys(state.validationMesssages).filter(
					key => state.validationMesssages[key].id !== action.field.id
				);
			}

			return {
				...state,
				invalidFields: updatedFields,
				validationMessages: updatedMessages,
			};
		default:
			return state;
	}
};

export const FormContext = createContext();

export const FormProvider = ({ initialState, children }) => (
	<FormContext.Provider value={useReducer(FormReducer, initialState)}>
		{children}
	</FormContext.Provider>
);

export const useFormValue = () => useContext(FormContext);
